import { render, staticRenderFns } from "./PushMessageSheet.vue?vue&type=template&id=22bfa686"
import script from "./PushMessageSheet.vue?vue&type=script&lang=js"
export * from "./PushMessageSheet.vue?vue&type=script&lang=js"
import style0 from "./PushMessageSheet.vue?vue&type=style&index=0&id=22bfa686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports